var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotifications = function SvgIconNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.563,
    height: 18.215,
    viewBox: "0 0 14.563 18.215",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8,30.749a2.146,2.146,0,0,0,2.19-2.413H14.6A2.147,2.147,0,0,0,16.8,30.749Z",
    transform: "translate(-9.526 -12.534)",
    fill: "#8d8585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.14,17.419c-.7-.924-2.08-1.466-2.08-5.6,0-4.247-1.876-5.955-3.624-6.364-.164-.041-.282-.1-.282-.269V5.05a1.111,1.111,0,1,0-2.222,0v.132c0,.168-.118.228-.282.269-1.753.414-3.624,2.117-3.624,6.364,0,4.138-1.379,4.675-2.08,5.6a.9.9,0,0,0,.724,1.448H20.42A.9.9,0,0,0,21.14,17.419Z",
    transform: "translate(-6.761 -3.93)",
    fill: "#8d8585"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-notifications.f6309a87.svg";
export { ForwardRef as ReactComponent };